module.exports = __webpack_public_path__ + "img/flechas_negras_derecha.98c43341.svg";